export default "__VITE_ASSET__JpZEIbRm__"